import React from "react";
import PlayerBoxView from "../../Pages/Pokemon/PlayerBoxView";

const PlayerProfileBoxTab = ({ username }) => {
  return (
    <PlayerBoxView username={username} embedded />
  );
};

export default PlayerProfileBoxTab;
